import request from "root/js/request";

export const getProductCardDetail = async ({
  cabinet_id,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/products_card_detail/",
    method: "get",
    params: {
      cabinet_id,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      ...rest,
    },
  });
  return response.data;
};
